import { PartnerOrganizationMigrationConfigResponseDto, } from '@lucidlink/dto/web-service-api';
import { parserFromDto } from '#fetcher';
export class PartnerOrganizationMigrationManagerImpl {
    partnerOrganizationFetcher;
    constructor(partnerOrganizationFetcher) {
        this.partnerOrganizationFetcher = partnerOrganizationFetcher;
    }
    async getMigrationConfig(query) {
        return this.partnerOrganizationFetcher.get(['migration-config'], {
            parser: parserFromDto(PartnerOrganizationMigrationConfigResponseDto),
            ...(query && { queryParams: { ...query } }),
        });
    }
    async createMigrationConfig(dto) {
        return this.partnerOrganizationFetcher.post(['migration-config'], {
            body: dto,
            parser: parserFromDto(PartnerOrganizationMigrationConfigResponseDto),
        });
    }
    async deleteMigrationConfig() {
        return this.partnerOrganizationFetcher.delete(['migration-config']);
    }
    async getFilespacesMigrationConfig(query) {
        return this.partnerOrganizationFetcher.get(['filespaces-migration-config'], {
            parser: parserFromDto(PartnerOrganizationMigrationConfigResponseDto),
            ...(query && { queryParams: { ...query } }),
        });
    }
    async createFilespacesMigrationConfig(dto) {
        return this.partnerOrganizationFetcher.post(['filespaces-migration-config'], {
            body: dto,
            parser: parserFromDto(PartnerOrganizationMigrationConfigResponseDto),
        });
    }
    async updateFilespacesMigrationConfig(dto) {
        return this.partnerOrganizationFetcher.patch(['filespaces-migration-config'], {
            body: dto,
            parser: parserFromDto(PartnerOrganizationMigrationConfigResponseDto),
        });
    }
    async deleteFilespacesMigrationConfig() {
        return this.partnerOrganizationFetcher.delete([
            'filespaces-migration-config',
        ]);
    }
    async migrateContract() {
        return this.partnerOrganizationFetcher.post(['billing-migration']);
    }
}
